import React, { useMemo } from 'react'
import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent'
import { Grid2 } from '@mui/material'
import { Constants, Grid_Gap } from '../../shared/constants';
import { Share } from '@mui/icons-material';
import { FloatingButton } from '../../shared/utils/IconButton';
import { getFileUrl } from '../../shared/utils/getFileUrl';
import { useMemoryByApart } from '../../assets/api/UseStudentGetApi';
import { SkeletonCom } from '../../shared/utils/SkeletonCom';




export const ImageCard = ({ src, height, isNested, isLoading }) => {
    if (isLoading) {
        return (
            <Grid2 item size={{ lg: isNested ? 12 : 4, xs: 12 }}>
                <SkeletonCom height={height} />
            </Grid2>
        );
    }

    const message = "Check out this awesome Memory!";
    const encodedMessage = encodeURIComponent(`${message} ${getFileUrl(src)}`);

    const handleWhatsAppShare = () => {
        window.open(
            `https://wa.me/?text=${encodedMessage}`,
            '_blank',
            'noopener,noreferrer'
        );
    };

    return (
        <Grid2 item size={{ lg: isNested ? 12 : 4, xs: 12 }} style={{ position: 'relative' }}>
            <img
                src={getFileUrl(src)}
                alt="Memory"
                style={{
                    height: `${height}px`,
                    width: '100%',
                    objectFit: 'cover',
                    borderRadius: "15px",
                }}
            />

            <FloatingButton
                onClick={handleWhatsAppShare}
                icon={<Share style={{ fontSize: '15px', color: '#000' }} />}
                bgcolor={"#C5D3FF"}
                sx={{ p: 1, top: 10, right: 10 }}
            />
        </Grid2>
    );
};

const Memories = () => {

    const {
        data,
        isLoading,
    } = useMemoryByApart({ perPage: 5 });
    const allMemories = data?.pages.flatMap((page) => page.data) || [];
    const imageList = useMemo(() => {
        return allMemories.map((item, index) => ({
            src: item.memories_images,
            height: index % 3 === 0 ? 400 : 195,
        }));
    }, [allMemories]);
    const count = isLoading ? 4 : imageList.length;
    return (
        <NormalContainerWithHeader headerText={"Memories"}>
            <Grid2 container spacing={Grid_Gap}>
                {/* 1st */}
                {count >= 1 && (
                    <ImageCard
                        src={imageList?.[0]?.src}
                        height={400}
                        isLoading={isLoading}
                    />
                )}

                {/* 2 + 3 */}
                {count >= 2 && (
                    <Grid2
                        container
                        size={{ lg: 4, xs: 12 }}
                        direction="column"
                        spacing={1}
                        justifyContent="space-between"
                    >
                        <ImageCard
                            src={imageList?.[1]?.src}
                            height={195}
                            isNested
                            isLoading={isLoading}
                        />

                        {count >= 3 && (
                            <ImageCard
                                src={imageList?.[2]?.src}
                                height={195}
                                isNested
                                isLoading={isLoading}
                            />
                        )}
                    </Grid2>
                )}

                {/* 4th */}
                {count >= 4 && (
                    <ImageCard
                        src={imageList?.[3]?.src}
                        height={400}
                        isLoading={isLoading}
                    />
                )}
            </Grid2>
        </NormalContainerWithHeader>
    )
}

export default Memories